module.exports = __webpack_public_path__ + "static/img/2.4713ecf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/2.png
// module id = Xg26
// module chunks = 0